import { useQuery } from "@tanstack/react-query";
import { api } from "../../../api";
import { OrgCategory } from "../../../generated/core-api";

/**
 * Hook for listing organization invitations
 */
export function useListOrgInvitations(category?: OrgCategory, orgId?: string) {
  return useQuery({
    queryKey: ["orgs", category, orgId, "invitations"],
    queryFn: () =>
      api.listInvitationsByOrg(category as OrgCategory, orgId as string),
    enabled: !!category && !!orgId,
  });
}
